import { jsx as _jsx } from "react/jsx-runtime";
const LABELS = {
    gluten: "Gluten",
    dairy: "Dairy",
    eggs: "Eggs",
    soy: "Soy",
    nuts: "Tree nuts",
    peanuts: "Peanuts",
    sesame: "Sesame",
    fish: "Fish",
    crustaceans: "Crustaceans",
    molluscs: "Molluscs",
    celery: "Celery",
    mustard: "Mustard",
    lupin: "Lupin",
    sulphites: "Sulphites",
};
export function AllergenChip({ code, label }) {
    const text = label ?? LABELS[code];
    return (_jsx("span", { className: "inline-flex items-center rounded-pill bg-danger-soft px-2.5 py-1 text-caption font-medium text-danger", children: text }));
}
